import { atom, getDefaultStore } from 'jotai'
import useSWR from 'swr'

interface IPCountry {
  ip: string
  country: string
  country_3: string
  name: string
}

const store = getDefaultStore()
const ipCountryAtom = atom<string | null>(null)
export const setIPCountry = (country: string) => {
  store.set(ipCountryAtom, country)
}

export const useIPCountry = () => {
  return useSWR<string>(
    'geoip:country',
    async () => {
      const ipCountry = store.get(ipCountryAtom)
      if (ipCountry) {
        return ipCountry
      }

      // Fallback: use geojs
      // https://www.geojs.io/docs/v1/endpoints/country/
      const res = await fetch('https://get.geojs.io/v1/ip/country.json')
      const json: IPCountry = await res.json()
      return json?.country
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      focusThrottleInterval: 1000 * 60 * 60 * 24,
    },
  )
}
